import React, { useContext } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { AuthContext } from '../App'
import { LayoutDashboard, Upload, FileCheck, FolderOpen, LogOut } from 'lucide-react'

const Layout = ({ children, title, fullWidth = false }) => {
  const { user, logout } = useContext(AuthContext)
  const location = useLocation()
  const navigate = useNavigate()
  const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false)

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  const navItems = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/upload', icon: Upload, label: 'Upload Medicine' },
    { path: '/all-sets', icon: FolderOpen, label: 'All Medicine Sets' },
    { path: '/pushed-sets', icon: FileCheck, label: 'Pushed Medicine Excel' },
    { path: '/upload-surgical', icon: Upload, label: 'Upload Surgical Items' },
    { path: '/all-surgical-sets', icon: FolderOpen, label: 'All Surgical Data Sets' },
    { path: '/pushed-surgical-sets', icon: FileCheck, label: 'Pushed Surgical Excel' }
  ]

  return (
    <div className="flex min-h-screen">
      <aside className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''}`} data-testid="sidebar">
        <div className="sidebar-logo">
          {!sidebarCollapsed && (
            <>
              <div className="sidebar-title">e-HCMS</div>
              <div className="sidebar-subtitle">Medicine Upload</div>
            </>
          )}
          <button
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            className="collapse-button"
            data-testid="sidebar-collapse-button"
            title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {sidebarCollapsed ? '→' : '←'}
          </button>
        </div>
        
        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              data-testid={`nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <item.icon className="nav-icon" />
              {!sidebarCollapsed && item.label}
            </Link>
          ))}
          
          <button onClick={handleLogout} className="nav-item w-full text-left" data-testid="logout-button">
            <LogOut className="nav-icon" />
            {!sidebarCollapsed && 'Logout'}
          </button>
        </nav>
      </aside>

      <div className={`main-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <header className="header">
          <h1 className="header-title" data-testid="page-title">{title}</h1>
          <div className="user-profile">
            <div className="user-info">
              <div className="user-name" data-testid="user-name">{user?.full_name}</div>
              <div className="user-role" data-testid="user-role">{user?.role}</div>
            </div>
            <div className="user-avatar" data-testid="user-avatar">
              {user?.full_name?.charAt(0)?.toUpperCase()}
            </div>
          </div>
        </header>
        
        <div className={fullWidth ? "content-container-full" : "content-container"}>
          {children}
        </div>
        
        <footer className="app-footer">
          <div className="footer-content">
            Made by eHCMS
          </div>
        </footer>
      </div>
    </div>
  )
}

export default Layout